go-button-group {
  /**
    @prop --go-button-group-gap:
      gap size between buttons inside the group
      - default: 1rem
  */
  --go-button-group-gap: 1rem;

  display: flex;
  gap: var(--go-button-group-gap);
  flex-wrap: wrap;
  align-items: baseline;

  &.connected {
    flex-wrap: nowrap;
    gap: 0;
    go-button {
      margin-inline-end: -1px;
      &:first-of-type {
        .inner-button {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      &:last-of-type {
        .inner-button {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
      &:not(:first-of-type, :last-of-type) {
        --go-btn-radius: 0;
      }
    }
  }
}
